import { defineComponent } from 'vue'
import './styles.sass'

export default defineComponent({
  props: {
    items: {
      type: Array,
      default: () => []
    },
    onSelect: {
      type: Function,
      default: (value: Record<string, string>) => value
    }
  },
  setup (props, context) {
    function onSelect (item: Record<string, string>) {
      props.onSelect(item)
    }

    return () => {
      return (
        <div class="dropdown">
          <ul>
            {props.items.map((item: any) => (
              <li onClick={() => onSelect(item as Record<string, string>)}>
                { item.value }
              </li>
            ))}
          </ul>
        </div>
      )
    }
  }
})